import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-unpaid-granth-outstanding-detail',
  templateUrl: './unpaid-granth-outstanding-detail.component.html',
  styleUrls: ['./unpaid-granth-outstanding-detail.component.scss']
})
export class UnpaidGranthOutstandingDetailComponent implements OnInit {

  startDate: any = '';
  endDate: any = '';

  repName: any[] = [];
  offRepName: any[] = [];
  booksellerName: any[] = [];

  reportType = '';
  currentDate = new Date();

  // API Response
  UnpaidOutstandingInDetailFormBeans: any[] = [];

  // Totals
  UnpaidOutStandingIDTotal = 0;
  UnpaidOutStandingIDNetAmtTotal = 0;
  UnpaidOutStandingIDUnPaidTotal = 0;
  UnpaidOutStandingIDCrdtTotal = 0;

  constructor(
    private dialogRef: MatDialogRef<UnpaidGranthOutstandingDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {

    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;

    this.reportType = this.data?.reportType || '';

    this.repName = this.data?.repName || [];
    this.offRepName = this.data?.officeRepWise || [];
    this.booksellerName = this.data?.bookSellerWise || [];

    this.loadReport();
  }

  loadReport(): void {

    const req: any = {};

    if (this.startDate) {
      req.start_date = this.startDate;
    }

    if (this.endDate) {
      req.end_date = this.endDate;
    }

    if (this.repName.length) {
      req.rep_name = this.repName;
    }

    if (this.offRepName.length) {
      req.office_rep_name = this.offRepName;
    }

    if (this.booksellerName.length) {
      req.book_seller_name = this.booksellerName;
    }

    console.log('Request', req);

    this.service.getBookUnpaidOutstandingIndetailgranth(req).subscribe({

      next: (response: any) => {

        console.log('Outstanding Detail', response);

        this.UnpaidOutstandingInDetailFormBeans = response || [];

        // Reset totals
        this.UnpaidOutStandingIDTotal = 0;
        this.UnpaidOutStandingIDNetAmtTotal = 0;
        this.UnpaidOutStandingIDUnPaidTotal = 0;
        this.UnpaidOutStandingIDCrdtTotal = 0;

        this.UnpaidOutstandingInDetailFormBeans.forEach((item: any) => {

          if (item.rep_data && item.rep_data.length) {

            item.rep_data.forEach((rep: any) => {

              this.UnpaidOutStandingIDTotal += Number(rep.inv_amt_total) || 0;
              this.UnpaidOutStandingIDNetAmtTotal += Number(rep.net_amt_total) || 0;
              this.UnpaidOutStandingIDUnPaidTotal += Number(rep.unpaid_amt_total) || 0;
              this.UnpaidOutStandingIDCrdtTotal += Number(rep.crdt_amt_total) || 0;

            });

          }

        });

        console.log('Invoice Total :', this.UnpaidOutStandingIDTotal);
        console.log('Net Amount Total :', this.UnpaidOutStandingIDNetAmtTotal);
        console.log('Unpaid Total :', this.UnpaidOutStandingIDUnPaidTotal);
        console.log('Credit Total :', this.UnpaidOutStandingIDCrdtTotal);

        this.cdr.detectChanges();

      },

      error: (err) => {
        console.error('Error loading report', err);
      }

    });

  }

  printPageA4(): void {

    const printContent = document.getElementById('print-section');

    if (!printContent) {
      return;
    }

    const win = window.open('', '', 'width=1200,height=800');

    if (!win) {
      return;
    }

    win.document.write(`
      <html>
      <head>

        <title>Book Outstanding Detail Report</title>

        <style>

          @page{
            size:A4 landscape;
            margin:8mm;
          }

          body{
            font-family:Arial, sans-serif;
            font-size:12px;
            margin:0;
            padding:0;
          }

          table{
            width:100%;
            border-collapse:collapse;
          }

          th,td{
            border:1px solid #000;
            padding:5px;
            text-align:center;
          }

          thead{
            display:table-header-group;
          }

          tr{
            page-break-inside:avoid;
          }

        </style>

      </head>

      <body>

      ${printContent.innerHTML}

      </body>

      </html>
    `);

    win.document.close();

    setTimeout(() => {
      win.print();
      win.close();
    }, 500);

  }

  exportExcel(fileName: string): void {

    console.log('Export Excel:', fileName);

    // Add XLSX export logic here.

  }

  close(): void {
    this.dialogRef.close();
  }

}